<template>
  <ActionButton
    ref="actionButton"
    action="review"
    icon="done_all"
    :text="text"
    :title="title"
    :confirm="confirm"
    :size="size"
    :css="css"
    @clickAction="reviewRemediations()"
  />
</template>

<script>
import ActionButton from "../shared/action_button";

export default {
  components: {
    ActionButton
  },

  props: {
    inspectionId: String,
    projectId: String,
    text: {
      type: String,
      default: 'Review Remediations'
    },
    title: {
      type: String,
      default: 'Review All Remediations'
    },
    confirm: {
      type: String,
      default: 'All Remediations will be reviewed?'
    },
    size: {
      type: String,
      default: 'sm'
    },
    css: {
      type: String,
      default: ''
    }
  },

  methods: {
    reviewInspectionRemediations: function() {
      this.$refs.actionButton.isSpinnerVisible = true;

      app.graphql.get(
        "update.inspection.reviewRemediations",
        {
					input: {
						inspectionId: this.inspectionId
					}
        },
    
        (data) => {
        	const response = data.data.reviewInspectionRemediations;
    
					if (response.errors) {
						response.errors.forEach((error) => {
							app.ui.toast.add({
								priority: "warning",
								title: "Unable to update remediation",
								message: error
							});

              this.$refs.actionButton.isSpinnerVisible = false;
          	});
        	} else {
						app.ui.toast.add({
							priority: "success",
							title: "Inspection Remediations",
							message: "All inspection remediations from <strong>review</strong> status set to <strong>reviewed</strong>"
						});

            setTimeout(() => {
              this.$refs.actionButton.isSpinnerVisible = false;

              this.$emit("reviewed");
            }, 1000);
					}
        }
			);
    },

    reviewProjectRemediations: function() {
      this.$refs.actionButton.isSpinnerVisible = true;

			app.graphql.get(
        "update.project.reviewRemediations",
        {
					input: {
						projectId: this.projectId
					}
        },
    
        (data) => {
        	const response = data.data.reviewProjectRemediations;
    
					if (response.errors) {
						response.errors.forEach((error) => {
							app.ui.toast.add({
								priority: "warning",
								title: "Unable to update remediation",
								message: error
							});

              this.$refs.actionButton.isSpinnerVisible = false;
          	});
        	} else {
						app.ui.toast.add({
							priority: "success",
							title: "Project Remediations",
							message: "All project remediations from <strong>review</strong> status set to <strong>reviewed</strong>"
						});

            setTimeout(() => {
              this.$refs.actionButton.isSpinnerVisible = false;

              this.$emit("reviewed");
            }, 1000);
					}
        }
			);
    },

    reviewRemediations: function() {
      if (this.inspectionId) {
        this.reviewInspectionRemediations()
      }

      if (this.projectId) {
        this.reviewProjectRemediations()
      }
      
    }
  }
}
</script>
